import { useState } from "react";
import { useMe } from "../api/auth";
import { EyeIcon, EyeOffIcon } from "./NavIcons";

/** Whether personal data is masked on this screen. Only DEMO sessions get the toggle, and it
 *  starts masked; everyone else sees the data as before. */
export function useSensitiveMask(): { available: boolean; masked: boolean; toggle: () => void } {
  const me = useMe();
  const [hidden, setHidden] = useState(true);
  const available = Boolean(me.data?.demo);
  return { available, masked: available && hidden, toggle: () => setHidden((h) => !h) };
}

/** Eye button that shows/hides personal data (rendered only when the mask is available). */
export default function SensitiveToggle({
  mask,
}: {
  mask: ReturnType<typeof useSensitiveMask>;
}) {
  if (!mask.available) return null;
  const label = mask.masked ? "Show personal data" : "Hide personal data";
  return (
    <button
      type="button"
      className={mask.masked ? "btn small eye-toggle on" : "btn small eye-toggle"}
      onClick={mask.toggle}
      aria-pressed={mask.masked}
      title={label}
      aria-label={label}
    >
      {mask.masked ? <EyeOffIcon width={16} height={16} /> : <EyeIcon width={16} height={16} />}
      <span>{mask.masked ? "Hidden" : "Visible"}</span>
    </button>
  );
}
